import module from 'empresa/module.js'
import moment from 'moment'
import template from './template.html'

const YEAR = (new Date().getFullYear())

export class EmpresaConfiguracionRegistrosPatronalesComponent {
  empresaId
  registroPatronalId
  registrosPatronales
  agregarModificacion = false

  constructor (EmpresaConfiguracionRegistroPatronal) {
    this.EmpresaConfiguracionRegistroPatronal = EmpresaConfiguracionRegistroPatronal
  }

  $onInit () {
    this.promise = this.EmpresaConfiguracionRegistroPatronal.get(this.empresaId, this.registroPatronalId)
    .then(({data}) => {
      this.data = data
      this.data.historial = this.data.historial.map(i => ({
        fechaInicial: moment(i.fechaInicial).format(YEAR === i.fechaInicial.getFullYear() ? 'DD [de] MMMM' : 'DD [de] MMMM [del] YYYY'),
        fechaFinal: moment(i.fechaFinal).format(YEAR === i.fechaFinal.getFullYear() ? 'DD [de] MMMM' : 'DD [de] MMMM [del] YYYY'),
        primaDeRiesgo: i.primaDeRiesgo,
      }))
    })
    .catch((error) => (console.log(error.data | error)))
  }

  agregarHistorial () {
    this.agregarModificacion = true
  }

  agregar (data) {
    this.agregarModificacion = false
    if (data) {
      data.fechaInicial = moment(data.fechaInicial).format(YEAR === data.fechaInicial.getFullYear() ? 'DD [de] MMMM' : 'DD [de] MMMM [del] YYYY')
      data.fechaFinal = moment(data.fechaFinal).format(YEAR === data.fechaFinal.getFullYear() ? 'DD [de] MMMM' : 'DD [de] MMMM [del] YYYY')
      this.data.historial = [data, ...this.data.historial]
    }
  }
}

module.component('empresaConfiguracionRegistroPatronal', {
  controller: EmpresaConfiguracionRegistrosPatronalesComponent,
  template,
  bindings: {
    empresaId: '<',
    registroPatronalId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/configuracion/registroPatronal/component.js